import _ from 'lodash';

export function makeApiUrl(path) {
  const apiUrl = process.env.TEST_MODE ? 'https://testhost' : process.env.NEXT_PUBLIC_API_URL;

  return _.trimEnd(apiUrl, '/') + '/' + _.trimStart(path, '/');
}

export const convertToInternalLink = (url) =>
  typeof window !== 'undefined' && url?.includes(window.location.origin)
    ? url.replace(window.location.origin, '')
    : url;

export const getCurrentUrl = () => (typeof window !== 'undefined' ? window.location?.href : '');
export const getCurrentUrlHostname = () =>
  typeof window !== 'undefined' ? window.location?.hostname : '';
export const getCurrentUrlParams = () =>
  typeof window !== 'undefined' ? window.location?.search : '';
